// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Event = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Event.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");

var states = [
  [
    0,
    /* EMPTY */0
  ],
  [
    1,
    /* LOADING */1
  ],
  [
    2,
    /* DONE */2
  ]
];

function stringify(readyState) {
  switch (readyState) {
    case /* EMPTY */0 :
        return "EMPTY";
    case /* LOADING */1 :
        return "LOADING";
    case /* DONE */2 :
        return "DONE";
    
  }
}

function toJs(readyState) {
  var arg = ArrayUtils$SmartcutsMacros.shortcut((function (param) {
          if (param[1] === readyState) {
            return param[0];
          }
          
        }), states);
  var param = "Expect to find numeric value for readyState=" + stringify(readyState);
  return OptionUtils$SmartcutsMacros.getExn(param, arg);
}

function fromJs(number) {
  return ArrayUtils$SmartcutsMacros.shortcut((function (param) {
                if (number === param[0]) {
                  return param[1];
                }
                
              }), states);
}

function fromJsExn(number) {
  var arg = fromJs(number);
  var param = "Expect to find matching value of readyState for n=" + String(number);
  return OptionUtils$SmartcutsMacros.getExn(param, arg);
}

var include = Webapi__Dom__Event.Impl({});

var include$1 = Webapi__Dom__Event.Impl({});

function readyState(fileReader) {
  return fromJsExn(fileReader.readyState);
}

function readAsArrayBufferPromise(fileReader, blob) {
  return new Promise((function (resolve, param) {
                fileReader.onload = (function (loadEvent) {
                    return resolve({
                                TAG: /* Ok */0,
                                _0: Caml_option.nullable_to_opt(loadEvent.target.result)
                              });
                  });
                fileReader.onabort = (function (param) {
                    return resolve({
                                TAG: /* Error */1,
                                _0: /* FileReaderDidAbort */0
                              });
                  });
                fileReader.onerror = (function (errorEvent) {
                    return resolve({
                                TAG: /* Error */1,
                                _0: /* FileReaderDidError */{
                                  _0: errorEvent
                                }
                              });
                  });
                fileReader.readAsArrayBuffer(blob);
                
              }));
}

function readAsDataUrlPromise(fileReader, blob) {
  return new Promise((function (resolve, param) {
                fileReader.onload = (function (loadEvent) {
                    return resolve({
                                TAG: /* Ok */0,
                                _0: Caml_option.nullable_to_opt(loadEvent.target.result)
                              });
                  });
                fileReader.onabort = (function (param) {
                    return resolve({
                                TAG: /* Error */1,
                                _0: /* FileReaderDidAbort */0
                              });
                  });
                fileReader.onerror = (function (errorEvent) {
                    return resolve({
                                TAG: /* Error */1,
                                _0: /* FileReaderDidError */{
                                  _0: errorEvent
                                }
                              });
                  });
                fileReader.readAsDataURL(blob);
                
              }));
}

function make(prim) {
  return new FileReader();
}

function addEventListener(prim0, prim1, prim2) {
  prim0.addEventListener(prim1, prim2);
  
}

var ReadyState = {
  stringify: stringify,
  toJs: toJs,
  fromJs: fromJs,
  fromJsExn: fromJsExn
};

function LoadEvent_bubbles(prim) {
  return prim.bubbles;
}

function LoadEvent_cancelable(prim) {
  return prim.cancelable;
}

function LoadEvent_composed(prim) {
  return prim.composed;
}

function LoadEvent_currentTarget(prim) {
  return prim.currentTarget;
}

function LoadEvent_defaultPrevented(prim) {
  return prim.defaultPrevented;
}

var LoadEvent_eventPhase = include.eventPhase;

function LoadEvent_timeStamp(prim) {
  return prim.timeStamp;
}

function LoadEvent_type_(prim) {
  return prim.type;
}

function LoadEvent_isTrusted(prim) {
  return prim.isTrusted;
}

function LoadEvent_preventDefault(prim) {
  prim.preventDefault();
  
}

function LoadEvent_stopImmediatePropagation(prim) {
  prim.stopImmediatePropagation();
  
}

function LoadEvent_stopPropagation(prim) {
  prim.stopPropagation();
  
}

function LoadEvent_target(prim) {
  return prim.target;
}

var LoadEvent = {
  bubbles: LoadEvent_bubbles,
  cancelable: LoadEvent_cancelable,
  composed: LoadEvent_composed,
  currentTarget: LoadEvent_currentTarget,
  defaultPrevented: LoadEvent_defaultPrevented,
  eventPhase: LoadEvent_eventPhase,
  timeStamp: LoadEvent_timeStamp,
  type_: LoadEvent_type_,
  isTrusted: LoadEvent_isTrusted,
  preventDefault: LoadEvent_preventDefault,
  stopImmediatePropagation: LoadEvent_stopImmediatePropagation,
  stopPropagation: LoadEvent_stopPropagation,
  target: LoadEvent_target
};

function setOnload(prim0, prim1) {
  prim0.onload = prim1;
  
}

function ErrorEvent_bubbles(prim) {
  return prim.bubbles;
}

function ErrorEvent_cancelable(prim) {
  return prim.cancelable;
}

function ErrorEvent_composed(prim) {
  return prim.composed;
}

function ErrorEvent_currentTarget(prim) {
  return prim.currentTarget;
}

function ErrorEvent_defaultPrevented(prim) {
  return prim.defaultPrevented;
}

var ErrorEvent_eventPhase = include$1.eventPhase;

function ErrorEvent_timeStamp(prim) {
  return prim.timeStamp;
}

function ErrorEvent_type_(prim) {
  return prim.type;
}

function ErrorEvent_isTrusted(prim) {
  return prim.isTrusted;
}

function ErrorEvent_preventDefault(prim) {
  prim.preventDefault();
  
}

function ErrorEvent_stopImmediatePropagation(prim) {
  prim.stopImmediatePropagation();
  
}

function ErrorEvent_stopPropagation(prim) {
  prim.stopPropagation();
  
}

function ErrorEvent_target(prim) {
  return prim.target;
}

var $$ErrorEvent = {
  bubbles: ErrorEvent_bubbles,
  cancelable: ErrorEvent_cancelable,
  composed: ErrorEvent_composed,
  currentTarget: ErrorEvent_currentTarget,
  defaultPrevented: ErrorEvent_defaultPrevented,
  eventPhase: ErrorEvent_eventPhase,
  timeStamp: ErrorEvent_timeStamp,
  type_: ErrorEvent_type_,
  isTrusted: ErrorEvent_isTrusted,
  preventDefault: ErrorEvent_preventDefault,
  stopImmediatePropagation: ErrorEvent_stopImmediatePropagation,
  stopPropagation: ErrorEvent_stopPropagation,
  target: ErrorEvent_target
};

function setOnError(prim0, prim1) {
  prim0.onerror = prim1;
  
}

function setOnAbort(prim0, prim1) {
  prim0.onabort = prim1;
  
}

function DOMException_code(prim) {
  return prim.code;
}

function DOMException_name(prim) {
  return prim.name;
}

function DOMException_message(prim) {
  return prim.message;
}

var $$DOMException = {
  code: DOMException_code,
  name: DOMException_name,
  message: DOMException_message
};

function error(prim) {
  return prim.error;
}

function abort(prim) {
  prim.abort();
  
}

exports.make = make;
exports.addEventListener = addEventListener;
exports.ReadyState = ReadyState;
exports.LoadEvent = LoadEvent;
exports.setOnload = setOnload;
exports.$$ErrorEvent = $$ErrorEvent;
exports.setOnError = setOnError;
exports.setOnAbort = setOnAbort;
exports.readyState = readyState;
exports.$$DOMException = $$DOMException;
exports.error = error;
exports.abort = abort;
exports.readAsArrayBufferPromise = readAsArrayBufferPromise;
exports.readAsDataUrlPromise = readAsDataUrlPromise;
/* include Not a pure module */
